export interface Province {
  name: string;
  id: number;
  memberCount: number;
}

export interface ClubType {
  name: string;
  id: number;
}

export interface ClubWithLoginDetails {
  userId: string;
  clubId: number;
  email: string;
  firstname: string;
  lastname: string;
  mobileNumber: string;
  province: string;
  clubType: string;
  clubName: string;
  archived : boolean;
}

export interface EditClubDetails {
  userId: string;
  clubId: number;
  email: string;
  firstName: string;
  lastName: string;
  mobileNumber: string;
  provinceId: number;
  clubTypeId: number;
  clubName: string;
  password: string;
  archived : boolean;
}

export interface NewClubCamp {
  areaCamp: boolean;
  clubCampId: number;
  name: string;
  description: string;
  startDate: Date;
  endDate: Date;
}

export interface Gender {
  id: number;
  name: string;
}

export interface Grade {
  id: number;
  name: string;
}

export interface Ethnicity {
  id: number;
  name: string;
}

export interface HomeLanguage {
  id: number;
  name: string;
}


export interface ClubProjectType {
  name: string;
  id: number;
}

export interface ClubActivityType {
  name: string;
  id: number;
}

export class PaginationModel {
  constructor(public page: number,public pageSize: number, public searchText: string, public orderBy : string, public orderByDirection) {}
  
  public entityId: number;
}

export class AwardPaginationModel {
  constructor(public page: number,public pageSize: number, public searchText: string, 
    public orderBy : string, public orderByDirection, public gradeId : number) {}
  
  public entityId: number;
}

export class PaginationResult<T> {
  constructor(public count: number, public data: T){}
}


export class SummedPaginationResult<T> {
  constructor(public count: number, public data: T, public sum: number){}
}

export interface AwardLevel {
  id: number;
  description: string;
  minimumGrade: number;
  minimumGradeDetails : {
    id : number,
    name : string
  }
}

